export const ILLUSTS_PER_PAGE = 12
export const MESSAGES_PER_PAGE = 30
export const ALBUMS_PER_USER_LIMIT = 30
export const ALBUM_ILLUSTS_LIMIT = 300
export const ALBUM_NAME_MAX_LENGTH = 30
export const USERS_PER_PAGE = 30
export const SUSPENSION_LIFT_REQUEST_USER_COMMENT_MAX_LENGTH = 1000
export const SUSPENSION_LIFT_REQUEST_ADMIN_COMMENT_MAX_LENGTH = 5000
